// Toggle d'activation de la correction STT (correcteur vocal).
//
// Le correcteur est une fonctionnalité DISTINCTE de l'agent vocal
// (FeatureFlag.ASSISTANT_ENABLE_VOCAL) : il possède désormais son propre
// interrupteur, totalement découplé du flag vocal.
//
// ⚠️ État actuel : FORCÉ À false.
//    - Pas d'UI : l'utilisateur ne voit pas encore ce toggle.
//    - Pas de persistance : aucune valeur n'est stockée (ni local, ni backend).
//    => La correction STT ne se déclenche donc jamais pour le moment.
//
// 👉 Point de bascule unique : quand le toggle utilisateur (ou le feature flag
//    SDK `CORRECTIF_STT_IA`) sera câblé, c'est la seule valeur à modifier ici.
const STT_CORRECTION_ENABLED = false;

const useSttCorrectionEnabled = (): boolean => STT_CORRECTION_ENABLED;

export default useSttCorrectionEnabled;
